import * as v from './rules';

/**
 * Rules for the Masters screen, mirroring MasterDtos and the unique keys behind it.
 *
 * <p>Every master row is a name with a length cap, so one rule factory covers all four
 * tables rather than four near-identical copies drifting apart.
 */
export const masterName = (label, max) => (value) =>
  v.required(label)(value) ??
  (String(value).trim().length > max ? `${label} must be ${max} characters or fewer` : null);

/**
 * Server rejections that belong on a field rather than in the banner. Every "already
 * exists" lands on the name, because that is the field that has to change.
 */
export const MASTER_CODES = {
  state_name_taken: 'name',
  city_name_taken: 'name',
  board_name_taken: 'name',
  board_code_taken: 'code',
  subject_name_taken: 'name',
  designation_name_taken: 'name',
  class_level_name_taken: 'name',
  invalid_board_code: 'name',
  invalid_state: 'cityState',
};
